import { useGetCountry } from '#pplx/frontend/apps/ask/queries/cloudflare-queries/useGetCountry.js';
import { runWebNavigationalSearch } from '#pplx/frontend/apps/ask/queries/navigational-queries/runWebNavigationalSearch.js';
import { shouldRunNavigationalSearch } from '#pplx/frontend/apps/ask/queries/navigational-queries/shouldRunNavigationalSearch.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
export const useRunNavigationalSearch = () => {
    const queryClient = useQueryClient();
    const country = useGetCountry();
    return useCallback(({ query, params, reason, streamTimer, isComet, streamId, }) => {
        const shouldRun = shouldRunNavigationalSearch({
            query,
            isFollowup: !!params.last_backend_uuid,
            attachmentsLength: params.attachments.length,
            sourcesLength: params.sources?.length ?? 0,
            modelPreference: params.model_preference,
        });
        if (shouldRun) {
            const userIdentity = {
                lang: params.language,
                country: country,
            };
            runWebNavigationalSearch({
                query,
                userIdentity,
                queryClient,
                reason,
                streamTimer,
                isComet,
                streamId,
            });
        }
    }, [queryClient, country]);
};
//# sourceMappingURL=useRunNavigationalSearch.js.map